import { Controller } from 'stimulus'

export default class PopupController extends Controller {
  static targets = [ 'actionBtn',  'content']

  connect() {
    $(this.actionBtnTarget).popup({
      popup: $(this.contentTarget),
      on: 'click',
      position: $(this.contentTarget).data('position')
    })
  }
}
